<script setup lang="ts">
  import { useBvModal } from '@bv/components/modal/composables/modal-context';
  import { trans } from '@bv/utils/i18n';
  import useVuelidate from '@vuelidate/core';
  import { required, minValue } from '@vuelidate/validators';
  import { ref } from 'vue';

  import { walletApi } from '@/api/wallet';

  const rechargeAmount = ref<number | undefined>(undefined);

  const rules = {
    rechargeAmount: { required, minValue: minValue(10) },
  };

  const v$ = useVuelidate(rules, { rechargeAmount });

  const handleRecharge = async () => {
    if (!(await v$.value.$validate())) {
      return;
    }
    const res = await walletApi.create({ payment_amount: rechargeAmount.value });
    window.open(res.url, '_blank');
    modal.close();
  };

  const modal = useBvModal({ onConfirm: handleRecharge });
</script>

<template>
  <p class="mb-6 text-gray-900">
    {{ trans('wallet.wallet_note_trans') }}
  </p>
  <bv-text-input
    v-model="v$.rechargeAmount.$model"
    autofocus
    :error-messages="v$.rechargeAmount.$errors[0]?.$message.toString()"
    :label="trans('wallet.amount_label_trans')"
    :placeholder="trans('wallet.amount_placeholder_trans')"
    type="number"
  />
</template>
